import {
  EstadoTransitoInventarioENUM,
  mapSeriesToSeriesMetros,
  ROUTER_PATHS,
  sanitizeTodos,
  texto,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import { useFetchCreateTransferenciaInventario } from "@/shared/actions/erp";
import {
  useFetchGetTransitoInventario,
  useFetchPutTransitoInventario,
} from "@/shared/actions/erp/transito_inventaro.actions";
import { GeneralTable, LoaderComponent } from "@/shared/components/ui";
import { useTableSolicitudTransferenciaInventario } from "@/shared/hooks/useTableSolicitudTransferenciaInventario";
import {
  EstadoSolicitudTransferencia,
  MaterialTransferido,
} from "@/shared/interfaces";
import { ITransitoInventario } from "@/shared/interfaces/erp/administration/transito_inventario.interface";
import { useBodegaStore } from "@/store/erp";
import { useUiStore } from "@/store/ui";
import { Edit } from "@mui/icons-material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { Grid, IconButton } from "@mui/material";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { TransferenciaInventarioFiltro } from "../../transferencia-inventario/TransferenciaInventarioFiltro";
import { TransferenciaInventarioFilter } from "../table_transferencia_inventario";
interface TablaTransTransitoInventarioProps {
  estado_solicitud?: string;
  enable_action?: boolean;
}

const TablaTransTransitoInventario = ({
  estado_solicitud = EstadoSolicitudTransferencia.EN_ESPERA,
  enable_action = true,
}: TablaTransTransitoInventarioProps) => {
  const navigate = useNavigate();

  ///* form
  const form = useForm<TransferenciaInventarioFilter>({
    defaultValues: {
      producto_codigo: null,
      producto_serie: null,
      fecha_creacion_after: dayjs().subtract(30, "day").format("YYYY-MM-DD"),
      fecha_creacion_before: dayjs().format("YYYY-MM-DD"),
    },
  });

  ///* store
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const bodegaTransito = useBodegaStore((s) => s.bodegaTransito);
  const ubicacionTransito = useBodegaStore((s) => s.ubicacionTransito);

  const { columnaTrasladoInventarioEnEspera } =
    useTableSolicitudTransferenciaInventario();

  const { globalFilter, pagination, setPagination } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  ///* react query
  const {
    isLoading,
    data: transferenciaProducto,
    isRefetching,
  } = useFetchGetTransitoInventario({
    page: pageIndex + 1,
    page_size: pageSize,
    estado_transito: estado_solicitud,
    numero_referencia: globalFilter,
    producto_codigo: sanitizeTodos(form.getValues().producto_codigo),
    producto_serie: sanitizeTodos(form.getValues().producto_serie),
    fecha_creacion_after: form.getValues().fecha_creacion_after,
    fecha_creacion_before: form.getValues().fecha_creacion_before,
    ...filterObject,
    filterByState: false,
  });

  const {
    mutateAsync: mutateAsyncTransferenciaProducto,
    isPending: isPendingTraslado,
  } = useFetchCreateTransferenciaInventario();

  const {
    mutateAsync: mutateAsyncPutTransito,
    isPending: isLoadingPutTransito,
    //isRefetching: isRefetchingPutTransito
  } = useFetchPutTransitoInventario({});

  ///* handle
  const onEdit = (data: ITransitoInventario) => {
    navigate(
      `${ROUTER_PATHS.inventario.trasladoInventarioEditNav}/${data.id_transito_inventario}`,
    );
  };

  const handleCrearTrasladoInventario = (data: ITransitoInventario) => {
    console.log("data", data);

    setConfirmDialogIsOpen(true);
    setConfirmDialog({
      cancelTextBtn: "Salir",
      isOpen: true,
      title: "¡Confirmar!",
      subtitle: texto.transito_inventario,
      onClose() {
        setConfirmDialogIsOpen(false);
      },
      async onConfirm() {
        try {
          delete data.codigo;
          delete data.numero_referencia;

          delete data.bodega_destino_data;
          delete data.bodega_origen_data;
          delete data.bodega_transito_data;

          delete data.ubicacion_destino_data;
          delete data.ubicacion_origen_data;
          delete data.ubicacion_transito_data;

          delete data.traslado_inicial_data;

          /* const trasfe = {
            ...data,
            bodega_origin: bodegaTransito?.codigo,
            ubicacion_origin: ubicacionTransito?.codigo
          }
          console.log('transfe', trasfe) */

          setConfirmDialogIsOpen(false);

          const resp = await mutateAsyncTransferenciaProducto({
            ...data,

            bodega_destino: bodegaTransito?.codigo, ///aqui se estaba haciedo la transferencia al origen mismo
            ubicacion_destino: ubicacionTransito?.codigo,
          });

          //const materialList: MaterialTransferido[] = data.productos?.map((element) => {
          const materialList: MaterialTransferido[] = resp.data.productos?.map(
            ({ series_destino, series_origen, ...element }) => {
              return {
                ...element,
                cantidad_esperada: element.cantidad,
                cantidad_acumulada: "0",
                cantidad: "0",
              };
            },
          );

          const nuevoSeriesData = mapSeriesToSeriesMetros(materialList);

          await mutateAsyncPutTransito({
            id: data?.id_transito_inventario!,
            data: {
              ...data,
              bodega_transito: bodegaTransito?.codigo,
              ubicacion_transito: ubicacionTransito?.codigo,
              productos: nuevoSeriesData ?? [],
              traslado_inicial: resp.data.codigo,
              estado_transito: EstadoTransitoInventarioENUM.EN_TRANSITO,
            },
          });
        } catch (error) {
        } finally {
          setConfirmDialogIsOpen(false);
        }
      },
    });
  };

  if (isPendingTraslado) return <LoaderComponent />;

  return (
    <Grid container spacing={3} sx={{ paddingTop: 2 }}>
      <TransferenciaInventarioFiltro form={form} />

      <Grid item xs={12}>
        <GeneralTable<ITransitoInventario>
          columns={columnaTrasladoInventarioEnEspera}
          data={transferenciaProducto?.data.data || []}
          //
          isLoading={isLoading || isLoadingPutTransito}
          isRefetching={isRefetching || isLoadingPutTransito}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={transferenciaProducto?.data.count}
          // // actions
          // crud
          canDelete={false}
          positionActionsColumn="first"
          enableColumnActions={enable_action}
          enableEditing={true}
          canEdit={false}
          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          showCustomActionBtnSpace={true}
          actionsColumnSize={120}
          customActionBtnSpace={(data) => {
            return (
              <Grid container>
                <Grid item>
                  <IconButton onClick={() => onEdit(data)}>
                    <Edit />
                  </IconButton>
                </Grid>

                <Grid item>
                  <IconButton
                    onClick={() => handleCrearTrasladoInventario(data)}
                  >
                    <LocalShippingIcon color="warning" />
                  </IconButton>
                </Grid>
              </Grid>
            );
          }}
        />
      </Grid>
    </Grid>
  );
};

export default TablaTransTransitoInventario;
